<template>
    <section class="it-hero-wrapper">
        <div class="container-fluid">
            <div class="container">
                <BreadcrumbNode class="d-block d-lg-none" :article="this.$root.breadcrumbData.article" :section="this.$root.breadcrumbData.section"/>
                <div class="row">
                    <div class="col-12">
                        <HeroCard/>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="container" v-if="this.contentTree">
        <div style="position:relative; top:-4em" class="row">
            <SearchBar :treeContainer="this" />
            <hr>
            <div class="col-12" v-for="nodes in this.contentTree.chunk(this.contentTree.nodes.length / 2)" :key="nodes">
                <div class="col-12" v-for="node in nodes" :key="node.id">
                    <div class="m-2 shadow rounded" v-if="node.activeTitle">
                        <div class="p-3">
                            <ContainerNode :contentTree="this.contentTree" :node="node" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ChatBot/>
</template>

<script>
import { ref } from 'vue';

import lodash from 'lodash'
import { ContentTree } from '@/classes/tree.js'
import SearchBar from '../navigator/SearchBar.vue';
import ContainerNode from '../navigator/ContainerNode.vue';
import HeroCard from '../partials/HeroCard.vue'
import BreadcrumbNode from '../navigator/BreadcrumbNode.vue'
import ChatBot from '../partials/ChatBot.vue'

export default {
    name: "SectionView",
    components: {
        SearchBar,
        ContainerNode,
        BreadcrumbNode,
        ChatBot
    },
    props: {
        section: String
    },
    data() {
        return {
            contentTree: undefined,
            localSection: undefined
        }
    },
    async created() {
        if (! this.$root.contents) {
            await this.$root.fetchContents();
		}
        this.localSection = ref(this.section)
        await this.loadTree()
    },
    async mounted() {
        if (this.contentTree) {
            this.contentTree.setUnfiltered()
            this.updateContentTree();
        }
    },
    methods: {
        async loadTree() {

            //blocca l'esecuzione della funzione finché i contenuti non sono stati caricati
            if (this.$root.contentsLoading) {
                while (this.$root.contentsLoading) { 
                    await new Promise(resolve => setTimeout(resolve, 100));
                }
            }
            
            if (!this.$root.contents) {
                await this.$root.fetchContents();
            }
            
            // Now we can safely clone the contents
            let virtualTree = lodash.cloneDeep(this.$root.contents);
            var filteredSections = {}
            
            // Make sure virtualTree and its sections exist
            if (virtualTree && virtualTree.sections) {
                for (const [key, value] of Object.entries(virtualTree.sections)) {
                    // Make sure contentTree exists before using it
                    if (this.$root.contentTree) {
                        value.parentChain = this.$root.contentTree.getChain(value)
                        value.parentChain = value.parentChain ? value.parentChain : []
                        value.parentChain = value.parentChain.map(p => p.id)
                        if (value.parent === this.localSection || value.id == this.localSection || (value.parentChain && value.parentChain.includes(this.localSection))) {
                            if (value.id == this.localSection) {
                                value.parent = null
                            }
                            filteredSections[value.id] = value;
                        }
                    }
                }
                virtualTree.sections = filteredSections
                this.contentTree = new ContentTree(virtualTree)
                
                // Make sure contentTree exists before using getNodeById
                if (this.$root.contentTree) {
                    this.localSection = this.$root.contentTree.getNodeById({ id: null, childrens: this.$root.contentTree.nodes }, this.localSection)
                    let n = this.$root.contentTree.getSectionById({ id: null, childrens: this.$root.contentTree.nodes }, this.contentTree.nodes[0].id)
                    this.$root.loadBreadcrumb(n)
                }
            }
        },
        updateContentTree() { //notifica Vue dell'aggiornamento dei nodi del contentTree
            if (this.contentTree) {
                this.contentTree.nodes = [...this.contentTree.nodes];
            }
        }
    }
}
</script>